import emailjs from "@emailjs/browser";

export const emailSender = (body) => {
  return emailjs.send(
    process.env.REACT_APP_SERVICE_ID, // Replace with your EmailJS Service ID
    process.env.REACT_APP_TEMPLATE_ID, // Replace with your EmailJS Template ID
    {
      name: body.name,
      email: body.email,
      phone: body.phone,
      description: body.description,
    },
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY // Replace with your EmailJS Public Key
  );
};